export { default as AccountSettingsConfig } from './AccountSettingsConfig';
